import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewPortfolioComponent } from 'src/app/pages/new-portfolio/new-portfolio.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { DisabledInvestmentCreationGuard } from 'src/app/services/disabled-investment-creation.guard';

const routes: Routes = [
  {
    path: 'new',
    component: NewPortfolioComponent,
    canActivate: [AuthenticationService, DisabledInvestmentCreationGuard],
  },
  {
    path: 'edit/:portfolioId',
    component: NewPortfolioComponent,
    canActivate: [AuthenticationService, DisabledInvestmentCreationGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortfolioRoutingModule { }
